import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { carrierUrls } from "../../URL/ApplicationUrls";
import Carrier from "../Carrier";
import { MdmApiError } from "../../Errors/MdmApiError";

import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useUpdateCarrier = () => {
  return useMutation({
    mutationFn: (carrier: Carrier) => {
      return axios.put<Carrier>(carrierUrls.carrierWithId(carrier.Id).apiUrl, carrier);
    },
    onSuccess: async (response: AxiosResponse<Carrier>) => {
      toast.success(`Updating the carrier with the Id ${response.data.Id} was successful`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
